<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import { initApiClient } from './services/apiClient'
import { useAuth } from './composables/useAuth'

export default {
  name: 'App',
  components: {
    Header
  },
  setup() {
    const { getAccessToken, isLoading } = useAuth()
    initApiClient(getAccessToken, () => isLoading.value)
  }
}
</script>

<style>
/* 1. Reset default browser margins */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f8f9fa; /* Matches your light theme */
}

/* 2. Force the Vue app container to fill the screen */
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Optional: Make scrollbars prettier */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
::-webkit-scrollbar-thumb {
  background: #ccc; 
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #bbb; 
}
</style>